import React, {PureComponent} from 'react';
import i18n from '../../../utils/i18n';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '@adsk/bim360-matrix-react-button';
import Text from '@adsk/bim360-matrix-react-text';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import Checkbox from '@adsk/bim360-matrix-react-checkbox';
import {ISSUE_ATTRIBUTES_DELETE_CHECKBOXES} from '../../../constants/issue-attributes';

class IssueAttributesAdminDeleteConfirmationModal extends PureComponent {
  constructor(props) {
    super(props);

    this.checkboxesKeys = Object.keys(ISSUE_ATTRIBUTES_DELETE_CHECKBOXES);

    this.state = {
      deleteTermStatuses: this.initializeDeleteTermStatuses(),
      deleteTermsNotAcceptedWarningShown: false
    };

    this.checkTermsAcceptedAndDeleteIssueAttribute = this.checkTermsAcceptedAndDeleteIssueAttribute.bind(this);
    this.updateDeleteCheckedStatuses = this.updateDeleteCheckedStatuses.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isOpen && nextProps.isOpen) {
      this.setState({
        deleteTermsNotAcceptedWarningShown: false,
        deleteTermStatuses: this.initializeDeleteTermStatuses()
      });
    }
  }

  initializeDeleteTermStatuses() {
    return this.checkboxesKeys.reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
  }

  checkTermsAcceptedAndDeleteIssueAttribute() {
    const {deleteTermStatuses} = this.state;
    const allCheckboxesChecked = this.checkboxesKeys.every(key => deleteTermStatuses[key] === true);
    if (allCheckboxesChecked) {
      this.props.deleteIssueAttribute();
    } else {
      this.setState({
        deleteTermsNotAcceptedWarningShown: true
      });
    }
  }

  updateDeleteCheckedStatuses(status, value) {
    this.setState({
      deleteTermStatuses: {
        ...this.state.deleteTermStatuses,
        [status]: value
      }
    });
  }

  _renderCheckbox(status, label, dataTestId) {
    const {deleteTermStatuses, deleteTermsNotAcceptedWarningShown} = this.state;
    const checkboxClass = cx('IssueAttributesAdminDeleteConfirmationModal__checkbox', {
      'IssueAttributesAdminDeleteConfirmationModal__checkbox--error':
        !deleteTermStatuses[status] && deleteTermsNotAcceptedWarningShown
    });
    const wrapWithText = text => <Text hasHTML>{text}</Text>;

    return (
      <Checkbox
        onChange={this.updateDeleteCheckedStatuses.bind(this, status)}
        checked={deleteTermStatuses[status]}
        className={checkboxClass}
        data-testid={dataTestId}
        label={wrapWithText(label)}
      />
    );
  }

  _renderMessage() {
    const {deleteTermsNotAcceptedWarningShown} = this.state;
    return (
      <div
        className="IssueAttributesAdminDeleteConfirmationModal"
        data-testid="IssueAttributesAdminDeleteConfirmationModal"
      >
        <Text className="IssueAttributesAdminDeleteConfirmationModal__message" hasHTML>
          {i18n.t('issueAttributesAdmin.modal.deleteTwoStepMessage')}
        </Text>
        <div className="IssueAttributesAdminDeleteConfirmationModal__terms">
          {this._renderCheckbox(
            ISSUE_ATTRIBUTES_DELETE_CHECKBOXES.OPEN,
            i18n.t('issueAttributesAdmin.modal.deleteFromOpenIssues'),
            'IssueAttributesAdminEditModal__checkbox-open-issues'
          )}
          {this._renderCheckbox(
            ISSUE_ATTRIBUTES_DELETE_CHECKBOXES.CLOSED,
            i18n.t('issueAttributesAdmin.modal.deleteFromClosedIssues'),
            'IssueAttributesAdminEditModal__checkbox-closed-issues'
          )}
          {this._renderCheckbox(
            ISSUE_ATTRIBUTES_DELETE_CHECKBOXES.PROJECT,
            i18n.t('issueAttributesAdmin.modal.deleteFromProject'),
            'IssueAttributesAdminEditModal__checkbox-project'
          )}
        </div>
        {deleteTermsNotAcceptedWarningShown && (
          <div
            className="IssueAttributesAdminDeleteConfirmationModal__warning"
            data-testid="IssueAttributesAdminDeleteConfirmationModal__warning"
          >
            {i18n.t('issueAttributesAdmin.modal.confirmDelete')}
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <ModalConfirmation
        container={this.props.container}
        title={i18n.t('issueAttributesAdmin.modal.deleteTitle', {
          attributeName: this.props.title
        })}
        show={this.props.isOpen}
        onConfirm={this.checkTermsAcceptedAndDeleteIssueAttribute}
        disableModalExit={this.props.isDeleting}
        isOnConfirmInProgress={this.props.isDeleting}
        confirmationButtonLabelInProgress={i18n.t('issueAttributesAdmin.modal.inProgress')}
        onExited={this.props.closeModal}
        message={this._renderMessage()}
        confirmationButtonLabel={i18n.t('issueAttributesAdmin.modal.deleteAttribute')}
        confirmationButtonStyleType={Button.StyleType.DANGER}
      />
    );
  }
}

IssueAttributesAdminDeleteConfirmationModal.displayName = 'IssueAttributesAdminDeleteConfirmationModal';

IssueAttributesAdminDeleteConfirmationModal.propTypes = {
  title: PropTypes.string,
  isDeleting: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  container: PropTypes.object.isRequired,
  deleteIssueAttribute: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default IssueAttributesAdminDeleteConfirmationModal;
